import { InputText } from 'primereact/inputtext';
import { Dropdown, DropdownChangeParams } from 'primereact/dropdown';

import styles from './Filters.module.scss';
import { IFiltersProps } from './IFiltersProps';
import AddUser from '../add/AddUser';
import { useCookies } from 'react-cookie';

const Filters = ({
  divisionsOptions,
  securityRolesOptions,
  setFirstNameFilter,
  setLastNameFilter,
  setUsernameFilter,
  divisionFilter,
  setDivisionFilter,
  securityRoleFilter,
  setSecurityRoleFilter,
  setShouldReload,
}: IFiltersProps): JSX.Element => {
  const [cookies, setCookie] = useCookies([
    'usersDivision',
    'usersSecurityRole',
  ]); 
  
  return (
    <div className={styles.container}>
      <InputText
        className={styles.filter}
        placeholder="First name"
        onChange={e => {
          setFirstNameFilter(e.target.value);
        }}
      />
      <InputText
        className={styles.filter}
        placeholder="Last name"
        onChange={e => {
          setLastNameFilter(e.target.value);
        }}
      />
      <InputText
        className={styles.filter}
        placeholder="Username"
        onChange={e => {
          setUsernameFilter(e.target.value);
        }}
      />
      <Dropdown
        style={{ width: '14%' }}
        className={styles.filter}
        placeholder="Division"
        value={divisionFilter}
        options={divisionsOptions}
        onChange={(e: DropdownChangeParams) => {
          setDivisionFilter(e.target.value);
          setCookie("usersDivision", e.value);
        }}
      />
      <Dropdown
        style={{ width: '14%' }}
        className={styles.filter}
        placeholder="Security role"
        value={securityRoleFilter}
        options={securityRolesOptions}
        onChange={(e: DropdownChangeParams) => {
          setSecurityRoleFilter(e.target.value);
          setCookie("usersSecurityRole", e.value);
        }}
      />

      <AddUser setShouldReload={setShouldReload} />
    </div>
  );
};

export default Filters;
